export default "__VITE_ASSET__nNknMYrS__"